import { MODELS } from '../../constants/admin/settings';
import { ADMIN_MODAL_FORMS } from '../../constants/actions';
import { LOCATION_CHANGE } from 'react-router-redux';
import { set } from 'dot-prop-immutable';

const initialState = {
    open: false,
    submitting: false,
    fetchingDependencies: false,
    fetchedDependencies: false,
    dependencies: {},
    edited: false,
    error: '',
    [MODELS.PERMISSION]: {
        function: '',
        group: '',
        name: '',
        orgId: '',
        eventId: '',
        accessToPerformanceContracts: false,
        accessToClearanceContracts: false
    },
    [MODELS.EVENT_EMAIL_SENDER]: {
        name: '',
        email: ''
    },
    [MODELS.COPY_PARTNER_CLEARANCE]: {
        partnerId: ''
    },
    [MODELS.BULK_PARTNERS_EMAIL]: {
        text: '',
        subject: ''
    },
    [MODELS.CONTRACT_REMINDER]: {
        comments: ''
    },
    [MODELS.CONTRACT_UPLOAD]: {
        file: '',
        comments: '',
        state: ''
    },
    [MODELS.CONTRACT_PARTNER]: {
        live: '',
        nonLinear: '',
        useUntil: 0,
        partnerId: '',
        comments: ''
    },
    [MODELS.EVENT_PARTNER]: {
        partnerIds: [],
        categoryIds: []
    },
    [MODELS.SET_VISIBLE_CATEGORIES]: {
        categoryIds: []
    },
    [MODELS.EVENT_ARTIST]: {
        artistIds: [],
        eventIds: []
    },
    [MODELS.STAGE]: {
        number: '',
        dates: []
    },
    [MODELS.BULK_PERFORMANCE]: {
        type: '',
        comments: '',
        useUntil: '',
        live: '',
        nonLinear: '',
        partners: []
    },
    [MODELS.BULK_SET_EVENTS]: {
        eventIds: []
    }
};

function reducer(state = initialState, action) {
    switch (action.type) {
        case ADMIN_MODAL_FORMS.SET:
            return set(state, action.field, action.value);
        case ADMIN_MODAL_FORMS.OPEN:
            return { ...state, open: true };
        case ADMIN_MODAL_FORMS.INITIALIZE:
            return { ...state, [action.model]: action.item, open: true };
        case ADMIN_MODAL_FORMS.FETCH_START:
            return { ...state, [`fetching${action.dependencies ? 'Dependencies' : ''}`]: true };
        case ADMIN_MODAL_FORMS.INPUT:
            return {
                ...state,
                edited: true,
                error: '',
                [action.model]: { ...state[action.model], [action.field]: action.value }
            };
        case ADMIN_MODAL_FORMS.FETCH_OK:
            return {
                ...state,
                [`fetching${action.dependencies ? 'Dependencies' : ''}`]: false,
                [`fetched${action.dependencies ? 'Dependencies' : ''}`]: true,
                [action.model]: action.data
            };
        case ADMIN_MODAL_FORMS.SUBMIT:
            return { ...state, submitting: true, error: '' };
        case ADMIN_MODAL_FORMS.FAILED:
            return { ...state, error: action.error, submitting: false };
        case LOCATION_CHANGE:
            return initialState;
        case ADMIN_MODAL_FORMS.SUCCESS:
        case ADMIN_MODAL_FORMS.CLOSE:
            return initialState;
        default:
            return state;
    }
}

export default reducer;
